import { Navigate } from "react-router-dom";
import { useAuthStore } from "@utils/stores/authStore.ts";
import { Center, Loader } from "@mantine/core";
import { AppRoutes } from "@/constants.ts";
import SmartWizLoader from "../SmartWizLoader/SmartWizLoader";

/**
 * RootRedirect component that handles the root "/" route.
 *
 * Behavior:
 * - Unauthenticated users → redirect to /getting-started (onboarding)
 * - Authenticated users → proceed to SmartWizLoader (which routes to appropriate home)
 */
const RootRedirect = () => {
  const { user, loading } = useAuthStore();

  // Show loader while checking authentication
  if (loading) {
    return (
      <Center w="100vw" h="100vh">
        <Loader color="blue" size="lg" />
      </Center>
    );
  }

  // Redirect unauthenticated users to onboarding
  if (!user?.email) {
    return <Navigate to={AppRoutes.login} replace />;
  }

  // User is authenticated, proceed to SmartWizLoader
  // SmartWizLoader will redirect to appropriate page based on role
  return <SmartWizLoader />;
};

export default RootRedirect;
